import React from 'react';

const SemanticScaleTable = ({ question }) => {
  const choices = question.questionChoicesAttributes || [];
  const configChoice = choices.find(c => c.kind === 'config');
  const data = question.results || [];

  if (question.responseFormat === 'points') {
    // Calculate total points for each row and grand total points
    const rowsWithPoints = data.map(row => {
      let totalPoints = 0;
      if (Array.isArray(row.frequencies)) {
        totalPoints = row.frequencies.reduce((sum, f) => sum + Number(f.val) * Number(f.count), 0);
      } else if (row.frequencies && typeof row.frequencies === 'object') {
        totalPoints = Object.entries(row.frequencies).reduce(
          (sum, [val, count]) => sum + Number(val) * Number(count),
          0
        );
      }
      return {
        ...row,
        totalPoints
      };
    });

    const grandTotalPoints = rowsWithPoints.reduce((sum, r) => sum + r.totalPoints, 0);

    return (
      <div className="table-responsive border rounded bg-white mt-3" style={{ overflow: 'hidden' }}>
        <table className="table table-hover mb-0" style={{ fontSize: '13px' }}>
          <thead style={{ backgroundColor: '#f8f9fa', color: '#718096', borderBottom: '1px solid #edf2f7' }}>
            <tr>
              <th className="font-weight-bold py-2 px-3 text-uppercase" style={{ borderBottom: 'none' }}>
                Respuesta
              </th>
              <th
                className="font-weight-bold py-2 px-3 text-center text-uppercase"
                style={{ borderBottom: 'none', width: '120px' }}
              >
                Puntos
              </th>
              <th
                className="font-weight-bold py-2 px-3 text-center text-uppercase"
                style={{ borderBottom: 'none', width: '100px' }}
              >
                Ratio
              </th>
            </tr>
          </thead>
          <tbody>
            {rowsWithPoints.map((row, idx) => {
              const ratio = grandTotalPoints > 0 ? ((row.totalPoints / grandTotalPoints) * 100).toFixed(1) : '0.0';
              return (
                <tr
                  key={row.id || row.name}
                  style={{ borderBottom: idx < rowsWithPoints.length - 1 ? '1px solid #edf2f7' : 'none' }}
                >
                  <td className="py-2 px-3 font-weight-medium text-dark">{row.name}</td>
                  <td className="py-2 px-3 text-center text-dark font-weight-semibold">{row.totalPoints}</td>
                  <td className="py-2 px-3 text-center font-weight-bold text-dark">{ratio}%</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  // Else, render semantic_differential as before
  const ticks = [];
  const range = configChoice?.label || '-3a3';
  const parts = range.split('a');
  const min = parseInt(parts[0], 10);
  const max = parseInt(parts[1], 10);
  for (let i = min; i <= max; i += 1) ticks.push(i);

  return (
    <div className="table-responsive border rounded bg-white mt-3" style={{ overflow: 'hidden' }}>
      <table className="table table-hover mb-0" style={{ fontSize: '13px' }}>
        <thead style={{ backgroundColor: '#f8f9fa', color: '#718096', borderBottom: '1px solid #edf2f7' }}>
          <tr>
            <th className="font-weight-bold py-2 px-3" style={{ borderBottom: 'none' }}>
              Izquierda
            </th>
            {ticks.map(t => (
              <th
                key={t}
                className="font-weight-bold py-2 px-1 text-center"
                style={{ borderBottom: 'none', minWidth: '40px' }}
              >
                {t}
              </th>
            ))}
            <th className="font-weight-bold py-2 px-3 text-right" style={{ borderBottom: 'none' }}>
              Derecha
            </th>
            <th
              className="font-weight-bold py-2 px-3 text-center"
              style={{ borderBottom: 'none', width: '100px', backgroundColor: '#edf2f7' }}
            >
              Ponderado
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={row.id || row.name} style={{ borderBottom: idx < data.length - 1 ? '1px solid #edf2f7' : 'none' }}>
              <td className="py-2 px-3 font-weight-medium text-dark">{row.name}</td>
              {ticks.map(t => {
                const count = Array.isArray(row.frequencies)
                  ? row.frequencies.find(f => String(f.val) === String(t))?.count || 0
                  : row.frequencies?.[String(t)] || 0;
                return (
                  <td key={t} className="py-2 px-1 text-center text-dark font-weight-semibold">
                    {count > 0 ? count : ''}
                  </td>
                );
              })}
              <td className="py-2 px-3 text-right text-dark">{row.rightLabel || ''}</td>
              <td className="py-2 px-3 text-center font-weight-bold text-dark" style={{ backgroundColor: '#f7fafc' }}>
                {row.average !== undefined ? row.average.toFixed(2) : '0.00'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SemanticScaleTable;
